import React from 'react';
import { COLORS } from '../utils/constants.js';
import Badge from '../components/Badge.jsx';

export default function Dashboard({ profile, contacts, sequences, grConnected, setActiveTab }) {
  const stats = [
    { label: 'Lead Credits', value: String(profile.credits), sub: 'remaining', color: COLORS.accent, icon: '⚡' },
    { label: 'AI Credits', value: '5,000', sub: 'available', color: COLORS.purple, icon: '✦' },
    { label: 'Contacts', value: String(contacts.length), sub: 'in database', color: COLORS.blue, icon: '◎' },
    { label: 'Sequences', value: String(sequences.length), sub: 'active', color: COLORS.green, icon: '◈' },
  ];

  const integrations = [
    { name: 'Apollo.io', desc: 'Lead database & enrichment', status: 'Connected', color: COLORS.green, features: ['People Search', 'Company Enrichment', 'Contact Management', 'Sequence Automation'] },
    { name: 'Claude AI', desc: 'Intelligent scoring & drafting', status: 'Active', color: COLORS.purple, features: ['Lead Scoring', 'Email Drafting', 'Company Analysis', 'Campaign Generation'] },
    { name: 'GetResponse', desc: 'Email marketing automation', status: grConnected ? 'Connected' : 'Setup Required', color: grConnected ? COLORS.green : COLORS.accent, features: ['Email Campaigns', 'Landing Pages', 'Autoresponders', 'Analytics'] },
  ];

  const actions = [
    { label: 'Find Prospects', tab: 'prospect', color: COLORS.blue },
    { label: 'Score a Lead', tab: 'ai-tools', color: COLORS.purple },
    { label: 'Draft Email', tab: 'ai-tools', color: COLORS.accent },
    { label: 'Research Company', tab: 'companies', color: COLORS.green },
    { label: 'Generate Campaign', tab: 'campaigns', color: COLORS.red },
    { label: 'Setup GetResponse', tab: 'getresponse', color: COLORS.blue },
  ];

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20, letterSpacing: -0.5 }}>
        Welcome back, <span style={{ color: COLORS.accent }}>Lionel</span>
      </h2>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16, marginBottom: 28 }}>
        {stats.map((s, i) => (
          <div key={i} style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}`, position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: -20, right: -20, width: 80, height: 80, borderRadius: '50%', background: `${s.color}08` }} />
            <p style={{ margin: 0, fontSize: 12, color: COLORS.textDim, fontWeight: 500, textTransform: 'uppercase', letterSpacing: 1 }}>{s.label}</p>
            <p style={{ margin: '8px 0 2px', fontSize: 32, fontWeight: 700, color: s.color, fontFamily: "'Space Mono', monospace" }}>{s.value}</p>
            <p style={{ margin: 0, fontSize: 12, color: COLORS.textMuted }}>{s.sub}</p>
            <span style={{ position: 'absolute', top: 16, right: 16, fontSize: 22, opacity: 0.4 }}>{s.icon}</span>
          </div>
        ))}
      </div>

      {/* Integrations */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 16 }}>
        {integrations.map((intg, i) => (
          <div key={i} style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>{intg.name}</h3>
              <Badge color={intg.color}>{intg.status}</Badge>
            </div>
            <p style={{ margin: '0 0 14px', fontSize: 13, color: COLORS.textMuted }}>{intg.desc}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {intg.features.map((f, j) => (
                <span key={j} style={{ padding: '3px 10px', borderRadius: 6, fontSize: 11, background: COLORS.surfaceAlt, color: COLORS.textMuted, border: `1px solid ${COLORS.border}` }}>{f}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div style={{ marginTop: 24 }}>
        <h3 style={{ fontSize: 14, fontWeight: 600, color: COLORS.textDim, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>Quick Actions</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
          {actions.map((a, i) => (
            <button key={i} onClick={() => setActiveTab(a.tab)} style={{ padding: '10px 18px', borderRadius: 8, border: `1px solid ${a.color}44`, background: `${a.color}11`, color: a.color, fontSize: 13, fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s', fontFamily: 'inherit' }}>
              {a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
